(() => {
  if (window.bikeStationProductTabsReady) return;
  window.bikeStationProductTabsReady = true;

  const selectTab = (tab, focus = false) => {
    const tabs = tab.closest('[data-bs-product-tabs]');
    if (!tabs) return;

    tabs.querySelectorAll('[role="tab"]').forEach((candidate) => {
      const selected = candidate === tab;
      const panel = document.getElementById(candidate.getAttribute('aria-controls'));
      candidate.setAttribute('aria-selected', String(selected));
      candidate.tabIndex = selected ? 0 : -1;
      if (panel) panel.hidden = !selected;
    });

    if (focus) tab.focus();
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const tab = event.target.closest('[data-bs-product-tabs] [role="tab"]');
    if (tab) selectTab(tab);
  });

  document.addEventListener('keydown', (event) => {
    if (!(event.target instanceof Element)) return;
    const tab = event.target.closest('[data-bs-product-tabs] [role="tab"]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const candidates = [...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];
    const index = candidates.indexOf(tab);
    let next = index;
    if (event.key === 'ArrowRight') next = (index + 1) % candidates.length;
    if (event.key === 'ArrowLeft') next = (index - 1 + candidates.length) % candidates.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = candidates.length - 1;
    event.preventDefault();
    selectTab(candidates[next], true);
  });

  const selectFromHash = () => {
    const id = window.location.hash.slice(1);
    if (!id.startsWith('ProductShipping-') && !id.startsWith('ProductInformation-')) return;
    const panel = document.getElementById(id);
    if (!panel?.matches('[data-bs-product-tabs] [role="tabpanel"]')) return;
    const tab = document.getElementById(panel.getAttribute('aria-labelledby'));
    if (!tab) return;
    selectTab(tab);
    requestAnimationFrame(() => panel.scrollIntoView({ block: 'start' }));
  };

  const initializeTabs = () => {
    document.querySelectorAll('[data-bs-product-tabs]').forEach((tabs) => {
      const initial = tabs.querySelector('[role="tab"][aria-selected="true"]') || tabs.querySelector('[role="tab"]');
      if (initial) selectTab(initial);
    });
    selectFromHash();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTabs, { once: true });
  } else {
    initializeTabs();
  }
  window.addEventListener('hashchange', selectFromHash);
})();
